module.exports = __webpack_public_path__ + "img/76.0d1607d8.jpg";